<template>
  <v-dialog v-model="dialogOpen" width="750" @click:outside="close">
    <v-card :loading="adhocInvoicesLoading">
      <v-card-title>Ad hoc History</v-card-title>
      <template v-if="!adhocInvoicesLoading">
        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table :headers="headers" :items="getAdhocInvoices" :hide-default-footer="true">
                <template v-slot:item.datetime="{ item }"><span class="body--text">{{ item.datetime | formatDate }}</span></template>
                <template v-slot:item.reference="{ item }"><span class="body--text">{{ item.reference }}</span></template>
                <template v-slot:item.total="{ item }"><span class="body--text">{{ item.total }}</span></template>
                <template v-slot:item.order_status="{ item }">
                  <span class="body--text" v-if="item.order_status != 'PENDING'">{{ item.order_status }}</span>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="body--text d-flex justify-start" v-bind="attrs" v-on="on">{{ item.order_status }}<v-icon>information</v-icon></div>
                    </template>
                    <span>Pre-live Telco hardware is ordered 4 days before the expected live date</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.download="{ item }">
                  <v-btn small color="secondary" @click="openInvoice(item)" :disabled="item.downloadLoading" :loading="item.downloadLoading"><v-icon small>{{downloadIcon}}</v-icon></v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small outlined @click="close">CLOSE</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapGetters } from 'vuex';
  import { mdiDownload } from '@mdi/js';
  const OLD_CRM_LINK = process.env.VUE_APP_API_HOST || `https://ctst-testing.appspot.com/`;
  export default {
    props: ['dialogOpen'],
    data() {
      return {
        toCrmUrl: OLD_CRM_LINK,
        downloadIcon: mdiDownload,
        headers: [
          {text: "Date & Time",sortable: false,value: "datetime"},
          {text: "Reference",sortable: false,value: "reference"},
          {text: "Total",sortable: false,value: "total"},
          {text: "Hardware Order",sortable: false,value: "order_status"},
          {text: "",sortable: false,value: "download"},
        ],
      }
    },
    computed: {
      ...mapState('adhoc', ['adhocInvoicesLoading']),
      ...mapGetters('adhoc', ['getAdhocInvoices']),
      ...mapState('accounts', ['currentAccount']),
    },
    watch: {
      async dialogOpen(open) {
        if(open){
          await this.fetchAdhocInvoices(this.currentAccount.id);
        }
      }
    },
    methods: {
      ...mapActions('adhoc',['fetchAdhocInvoices','downloadInvoice']),
      async openInvoice(item) {
        item.downloadLoading = true;
        await this.downloadInvoice(item);
        item.downloadLoading = false;
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
